//
// Copyright (c) 2011-2021 by Curalate, Inc.
//

import { createSelector } from 'reselect';

import { ICuralateStore } from '@models/AppState';
import { Normalized } from '@utils/normalize';
import { generateEmptyPin } from '@pinterest/redux/post-details/pinterestPostDetailsUtils';

/**
 * Gets the currently selected pin or returns the first one as a fallback
 */
export const getCurrentPin = createSelector(
  (state: ICuralateStore) => state.pinterest.postDetails.currentPinId,
  (state: ICuralateStore) =>
    state.pinterest.postDetails.currentPostDetails.pins,
  (currentPinId, pins) => {
    return (
      Normalized.getById(pins, currentPinId) ??
      Normalized.getOrdered(pins)[0] ??
      generateEmptyPin()
    );
  },
);
